import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
import { Router, NavigationEnd, ActivatedRoute  } from '@angular/router';
import * as moment from 'moment';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-indiatourmatch',
  templateUrl: './indiatourmatch.component.html',
  styleUrls: ['./indiatourmatch.component.scss']
})
export class IndiatourmatchComponent implements OnInit {
  
  contactRequest: any = {};
	contactError: any;
	contactSuccess: any; 
  route: string;
  currentURL='';
  public min: Date = new Date(1900, 1, 1, 12, 30);
  today = new Date();

  constructor(private allpagesService: AllPageService,
		private activatedRoute:ActivatedRoute,
    private router: Router,) {
      this.currentURL = window.location.href;
    }

  ngOnInit() {
  }
   
   clubContactus(form: NgForm) {
		if (form.valid) {
			if(jQuery("#email_notiification").prop("checked") == true)
			{
				//this.contactRequest.email_notification = "Yes";
			}else{
				//this.contactRequest.email_notification = "No";
			}
			//this.contactRequest.type = 'India Tour Match';
			//this.contactRequest.birth_date = moment(this.contactRequest.birth_date).format('YYYY-MM-DD');
			let request: any = {};
			request = Object.assign({}, this.contactRequest);
			this.allpagesService.newsSubscription(request).then((res) => {

				if (res.status == 0) {
					this.contactError = res.message;
				} else {
					this.contactSuccess = res.message;
					form.reset();
				}
			})
				.catch((err) => {
					this.contactError = err.res.message;
				});
		}
	}

}
